import { Component, input } from '@angular/core';

@Component({
    selector: 'gea-svg-event-stars',
    templateUrl: './event-stars.component.html',
    standalone: true
})
export class EventStarsComponent {
  size = input<number>(16)
  color = input<string>('currentColor')
}
